package com.macrofocus.high_d

import com.macrofocus.high_d.scatterplot.DefaultScatterPlotController
import com.macrofocus.high_d.scatterplot.DefaultScatterPlotView
import com.macrofocus.high_d.scatterplot.ScatterPlotModel
import react.FC
import react.Props

@JsExport
external interface ScatterPlotProps : Props {
    var model: ScatterPlotModel<Int, String>?
}

@JsExport
val ScatterPlot = FC<ScatterPlotProps> { props ->
//    val view = useMemo(props.model) {
        val view = DefaultScatterPlotView<Int, String>()
        view.model = props.model
        DefaultScatterPlotController<Int, String>(view)
//        view
//    }
    view.component.nativeComponent()
}
